// App.js (修改版)
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import Product from './pages/Product';
import UseCases from './pages/UseCases';
import AboutUs from './pages/AboutUs';
import NavBar from './components/NavBar'; // <--- 新增
import './App.css';

function App() {
  return (
    <div className="App">
      <NavBar /> {/* <--- 將 NavBar 放在這裡，它將在所有頁面顯示 */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/product" element={<Product />} />
        <Route path="/use-cases" element={<UseCases />} />
        <Route path="/about-us" element={<AboutUs />} />
      </Routes>
      {/* 如果您決定需要 footer，也可以再放回來 */}
      {/* <Footer /> */}
    </div>
  );
}

export default App;